// El API a veces responde texto plano o HTML en lugar de JSON (p. ej. "Error occurred..."
// desde el proxy o un 500). Se lee como texto y se intenta parsear: si no es JSON, devuelve {}.
export const readJson = async (response) => {
  const text = await response.text()
  try {
    return text ? JSON.parse(text) : {}
  } catch {
    return {}
  }
}

// Tipos de error: "user" (datos incorrectos), "server" (el API falló) y "connection" (sin red)
const SERVER_DOWN = "No pudimos comunicarnos con el servidor. Intente de nuevo en unos minutos."
const NO_CONNECTION = "Revise su conexión a internet e intente de nuevo."

// Error de una respuesta no ok. Los 5xx no muestran el detalle interno del servidor.
export const responseError = (response, data, fallback) => {
  if (response.status >= 500) return Object.assign(new Error(SERVER_DOWN), { kind: "server" })
  return new Error(data.error || fallback)
}

// Error listo para mostrar; fetch lanza TypeError cuando no hay red o el servidor no responde
export const describeError = (err, fallback) =>
  err instanceof TypeError
    ? { kind: "connection", message: NO_CONNECTION }
    : { kind: err.kind || "user", message: err.message || fallback }
